module.exports = __webpack_public_path__ + "img/10.d878908c.jpg";